<template>
  <Skeleton :class="cn('rounded-none bg-transparent', props.class)" data-slot="skeleton-marks"><slot /></Skeleton>
</template>

<script setup lang="ts">
// The skeleton pulse for a hand-drawn placeholder (chart marks, diagram boxes).
// Tint the marks inside with `fill-skeleton/10` or `bg-skeleton/10`.
import type { HTMLAttributes } from "vue";

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

const props = defineProps<{ class?: HTMLAttributes["class"] }>();
</script>
